import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import DataSource from "devextreme/data/data_source";
import ODataStore from 'devextreme/data/odata/store';
import { EnvironmentService } from '../../services/environment.service';

@Component({
  selector: 'app-batch-transaction',
  templateUrl: './batch-transaction.component.html',
  styleUrl: './batch-transaction.component.scss'
})
export class BatchTransactionComponent implements OnInit {
  dataSource: any;
  batchId?: string | null;
  isVisibleDetail: boolean = false;

  merchantDataSource: any;
  statusDataSource: any;
  batchDataSource: any;
  batch: any;
  ds: DataSource;


  constructor(private route: ActivatedRoute, private cdr: ChangeDetectorRef, private environmentService: EnvironmentService) {
    this.batchId = this.route.snapshot.queryParamMap.get('batchId');

    this.ds = new DataSource({
      store: new ODataStore({
        url:  this.environmentService.getConfig('BackendApi') + "odata/Batches",
        key: "Id"
      }),
      filter: ["Id", "=", 1]
    });
  }

  ngOnInit() {
    this.ds.load()
      .then(
        (data) => {
          this.batch = data[0];
          console.log(data);
        },
        (error) => { /* Handle the "error" here */ }
      )

    const batchId = this.batchId;

    if (this.batchId != null) {
      this.isVisibleDetail = true;
      this.dataSource = {
        store: {
          version: 4,
          type: 'odata',
          key: 'Id',
          url: this.environmentService.getConfig('BackendApi') + 'odata/DisbursementTransactions',
          beforeSend: function (request: any) {
            request.params.$filter = `BatchId eq ${batchId}`;
          }
        }
      };
    }
    else {
      this.dataSource = {
        store: {
          version: 4,
          type: 'odata',
          key: 'Id',
          url: this.environmentService.getConfig('BackendApi') + 'odata/DisbursementTransactions',
          beforeSend: function (request: any) {
          }
        }
      };
    }

    this.merchantDataSource = {
      store: {
        type: 'odata',
        url: this.environmentService.getConfig('BackendApi') + 'odata/Merchants',
        key: 'Id'
      }
    };

    this.statusDataSource = [
      { Id: 1, Value: 'Pending', Color: 'black' },
      { Id: 2, Value: 'Approved', Color: 'green' },
      { Id: 3, Value: 'Rejected', Color: 'red' }
    ];

    this.batchDataSource = {
      store: {
        type: 'odata',
        url: this.environmentService.getConfig('BackendApi') + 'odata/Batches',
        key: 'Id',
        beforeSend: function (request: any) {
          request.params.$filter = `Id eq ${batchId}`;
        }
      }
    };
  }

  isInteger(value: string): boolean {
    const number = parseInt(value, 10);
    return !isNaN(number) && Number.isInteger(number);
  }

  getStatusText(status: number): string {
    const statusObj = this.statusDataSource.find((s: any) => s.Id === status);
    return statusObj ? statusObj.Value : 'Unknown';
  }

  getStatusCellStyle(data: any): any {
    const statusObj = this.statusDataSource.find((s: any) => s.Id === data.Status);
    return statusObj ? { 'background-color': statusObj.Color } : {};
  }
}

